<ngb-carousel
  *ngIf="planData?.banners_plan?.length > 0"
  [showNavigationIndicators]="false"
  [showNavigationArrows]="false"
>
  <ng-template
    ngbSlide
    *ngFor="let banner of planData?.banners_plan; let i = index"
  >
    <img [src]="banner.url" class="d-block w-100" [alt]="banner.nombre" />
  </ng-template>
</ngb-carousel>
